import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { NetworkStatusService } from '../../services/network-status.service';

@Component({
  selector: 'app-offline-banner',
  templateUrl: './offline-banner.component.html',
  styleUrls: ['./offline-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OfflineBannerComponent {
  private network = inject(NetworkStatusService);
  readonly offline = this.network.offline;
}
